



































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import { evalSettingListModule } from '@/store/modules/frames/eval-setting-list.module';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GExamListTools',
  computed: {},
  methods: {},
})
export default class GExamListTools extends Mixins(GPageBase) {
  hasStatusCompleted: GEnum.RadioLabel = GEnum.RadioLabel.True;
  viewMode: number = 1;

  mounted() {
    this.viewMode = evalSettingListModule.viewMode;
  }

  handleToggleViewMode() {
    evalSettingListModule.setCurrentPageNum(1);
    evalSettingListModule.setViewMode(this.viewMode);
    this.$emit('handleFetchEvalSettings');
  }

  handleHasStatusCompleted() {
    evalSettingListModule.setCurrentPageNum(1);
    evalSettingListModule.setHasStatusCompleted(this.hasStatusCompleted);
    this.$emit('handleFetchEvalSettings');
  }

  handleNewProject() {
    this.$router.push(`/pages/exam/create?mode=${GEnum.EvalSettingMode.Create}`);
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }
}
